// MM screen input reason for change options
export const ReasonForChange = [
        "Manpower shortfall",
        "Increase in demand",
        "Low indent/Warehouse congestion",
        "No RPM",
        "Unplanned breakdown",
        "Planned shutdown",
    ];
export const smartProdSchedularInputFields = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
export const smartProdSchedularChipsCols = ["Overall RMPM coverage %", "Physical RMPM coverage %"];
export const smartProdSchedularDropdownCols = ["Reason for change", "Cascade", "Line"];
export const expectedInputColumns = ["Line", "Cascade", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
export const ID_COLS = ["CBU code","Site code","Site cluster","Format","PreCascade","PreLine","CBU description",];
export const SAPWeeklyPlanColumn = [{label:'SAP Weekly Plan', key:'SAP Weekly Plan', visibility:true, sortable:true}];


// color list for schedule view in dailyphasing
export const colors = ['#B2E8FF', '#B2F3ED', '#F1E0F4', '#FEE4F5', '#FFF7B2', '#D6F5FC', '#E3F6F1', '#F6EBF8', '#FFEBF8', '#FFF9E1', '#B2DBCB', '#D6B4EB', '#FFB5D7', '#FFE2B2', '#ECB9C1', '#A3E1D2', '#E1C7EC', '#FAD7EE', '#FFECB2']
